import { IInitiateChatResponse, IInitiateChatResponseV2 } from '@belong/types/api/chat';

// API is returning capitalized fields, but Amazon Connect's typings expect lower case.
export const parseChatDetails = (
  chatDetails: IInitiateChatResponse['data']['startChatResult']
): connect.ChatDetailsInput => {
  const { ContactId, ParticipantId, ParticipantToken } = chatDetails;
  return {
    contactId: ContactId,
    participantId: ParticipantId,
    participantToken: ParticipantToken
  };
};

// API is returning capitalized fields, but Amazon Connect's typings expect lower case.
export const parseChatDetailsV2 = (
  chatDetails: IInitiateChatResponseV2['data']['startChatResult']
): connect.ChatDetailsInput => {
  const { contactId, participantId, participantToken } = chatDetails;

  return {
    contactId,
    participantId,
    participantToken
  };
};
